<template>
  <div class="notification-bar" ref="notificationInner" id="notificationBarIns">
    <div
      class="notification-bar_icon_dot clickable-hint"
      @click="toggleNotificationBarVisable()"
    >
      <i class="notification-bar_icon"></i>
      <span v-if="hasUnReadMsg" class="notification-bar_dot"></span>
    </div>
    <transition name="fade">
      <div
        class="notification-bar_popup"
        v-show="notificationBarVisable"
      >
        <ul class="popup-msg_header">
          <li
            v-for="item in notificatioPreview.menu"
            :class="[
              'clickable-hint',
              item.id == dialogCategoryId && 'popup-msg_active'
            ]"
            :key="item.id"
            @click="bindMsgTypeTap(item.id)"
          >
            <span> {{ item.name }}（{{ item.unread }}）</span>
          </li>
        </ul>
        <div class="popup-msg_list">
          <div class="popup-msg_loading">
            {{
              dialogLoading
                ? "加载中..."
                : !notificatioPreview.dialog.length
                ? "没有消息"
                : ""
            }}
          </div>
          <div
            class="popup-msg_item clickable-hint"
            v-for="item in notificatioPreview.dialog"
            :key="item.id"
            @click="previewMsgOnNewWindows(item)"
          >
            <span
              :class="[
                'msg-item_state',
                Number(item.read) && 'msg-item_readed'
              ]"
            ></span>
            <div class="msg-item_content ">
              <div>
                {{ item.tip_name }}
              </div>
              <div>{{ item.create_time_text }}</div>
            </div>
          </div>
        </div>
        <ul class="popup-msg_header popup-msg_option">
          <li class="clickable-hint" @click="updateAllReadByCategoryId">
            全部已读
          </li>
          <li class="clickable-hint" @click="bindEventLookMore">
            查看更多
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import onlyViewMixin from "@/common/mixin/onlyViewMixin.js";
import { mapActions, mapGetters } from "vuex";
import { initWebSocket, websockClose } from "./webSockets";

export default {
  name: "NotificationBar",
  mixins: [onlyViewMixin],
  computed: {
    ...mapGetters("notification", [
      "hasUnReadMsg",
      "notificatioPreview",
      "notificationBarVisable",
      "dialogCategoryId",
      "dialogLoading"
    ])
  },
  methods: {
    ...mapActions("notification", [
      "initNotificationCategory",
      "toggleNotificationBarVisable",
      "updateCurrentCategoryId",
      "updateAllReadByCategoryId",
      "msgPreviewAction",
      "msgReadedAction"
    ]),
    /**
     * @description 点击区域外部关闭弹窗
     */
    outterViewClosePopup(event) {
      const notificationInner = this.$refs.notificationInner;
      if (notificationInner && !notificationInner.contains(event.target)) {
        return this.toggleNotificationBarVisable(true);
      }
    },
    /**
     * @description 切换popup的消息栏
     * @param categoryId {Number} 消息分类id
     */
    bindMsgTypeTap(categoryId) {
      let { dialogCategoryId } = this;
      if (categoryId !== dialogCategoryId) {
        this.updateCurrentCategoryId({ categoryId });
      }
    },
    /** 在新窗口打开  */
    previewMsgOnNewWindows(msg) {
      const { category_id, id, read } = msg;
      const { name } = this.$route;

      /** 不在消息中心操作  */
      if (name !== "notificationCenter") {
        /** 标记当前页面为已读 */
        if (Boolean(Number(read)) == false) {
          this.msgReadedAction(id);
        }
        this.toggleNotificationBarVisable();
        /** 打开新窗口 */
        let newTab = this.$router.resolve({
          path: `/notification/center?category_id=${category_id}&msg_id=${id}`
        });
        return window.open(newTab.href, "_blank");
      } else {
        /** 在消息中心页面同步 */
        return this.msgPreviewAction({
          msg: msg,
          macthMsg: true,
          center: true
        });
      }
    },
    bindEventLookMore() {
      const { name } = this.$route;
      this.toggleNotificationBarVisable();
      /** 不在消息中心操作  */
      if (name !== "notificationCenter") {
        let newTab = this.$router.resolve({ path: `/notification/center` });
        return window.open(newTab.href, "_blank");
      }
    }
  },
  mounted() {
    /** 挂载时先初始化消息分类 但是新窗口打开不执行初始化 */
    this.initNotificationCategory();
    /** 绑定点击外部事件 */
    document.addEventListener("click", this.outterViewClosePopup);
    /** 初始化socket推送 */
    initWebSocket();
  },
  destroyed() {
    document.removeEventListener("click", this.outterViewClosePopup);
    /** 组件卸载时间关闭socket  */
    websockClose();
  }
};
</script>

<style scoped lang="scss">
@mixin bgicon($url) {
  background-image: url($url);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

$colorReaded: #7f7f7f;
$colorDefault: #000;
$colorTabActive: #005bac;

.notification-bar {
  margin: 0 10px;
  position: relative;
  color: $colorDefault;
  align-self: center;

  .notification-bar_icon_dot {
    height: 42px;
    padding: 0 14px;
    position: relative;
    align-content: center;

    .notification-bar_icon {
      display: inline-block;
      width: 18px;
      height: 18px;
      @include bgicon(
        "~@/components/notificationBar/assets/icon-notification.png"
      );
      vertical-align: text-top;
      align-self: center;
    }

    .notification-bar_dot {
      width: 6px;
      height: 6px;
      background-color: #e44030;
      border-radius: 4px;
      position: absolute;
    }
  }

  .notification-bar_popup {
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 420px;
    // height: 383px;
    right: 0;
    border-radius: 4px;
    background: #fff;
    z-index: 9999;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
    overflow: hidden;

    .popup-msg_header {
      display: flex;
      justify-content: space-evenly;
      line-height: 48px;
      background: #fff;
      box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.08);
      margin-bottom: 11px;

      .popup-msg_active {
        color: $colorTabActive;
        font-weight: 600;
        border-bottom: 2px solid $colorTabActive;
      }
    }

    .popup-msg_list {
      .popup-msg_item {
        display: flex;
        padding: 7px 20px 6px 20px;

        .msg-item_state {
          display: block;
          width: 8px;
          height: 8px;
          background-color: #e44030;
          border-radius: 8px;
          margin: 8px 8px 0 0;
        }

        .msg-item_readed {
          background-color: #7f7f7f;
        }

        .msg-item_content {
          display: flex;
          flex-direction: column;
          line-height: 24px;
          flex: 1;

          :first-child {
            width: 360px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          :last-child {
            font-size: 12px;
            color: $colorReaded;
          }
        }
      }

      .popup-msg_item_readed {
        opacity: 0.6;
        filter: grayscale(1);
      }

      .popup-msg_loading {
        text-align: center;
        color: #7f7f7f;
        line-height: 30px;
        font-size: 14px;
      }
    }

    .popup-msg_option {
      justify-content: space-around;
      border-bottom: none;
      box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.08);
      margin-bottom: 0;
      margin-top: 16px;

      li {
        width: 50%;
        text-align: center;

        &:first-child {
          box-sizing: border-box;
          border-right: 1px solid #ebebeb;
        }
      }
    }
  }
}

.clickable-hint {
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/notificationBar/entry.vue